// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import React, { useContext, useEffect, useState, useRef} from "react";
import AppContext from "./hooks/createContext";
import { ToolProps } from "./helpers/Interfaces";
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import { CheckCircleFill } from 'react-bootstrap-icons';
import * as _ from "underscore";
import { thingmojiSend } from "../routes/socket";
import {handleThingmojiDoubleClick} from "../chat/histgram";

import { imageDataToImage } from "./helpers/maskUtils";
import { resizeImage, resizeImage_original, removeBlankSpace, DimBlankSpace } from "./helpers/imageUtils";

// type imageItem = {
//   image: string,
//   originalImage: string,
//   index: number
// }
// type messageItem ={
//   texts:string[],
//   images:imageItem[],
//   index:number
// }

const Tool = ({ handleMouseDown, handleMouseUp, handleMouseMove,peekwindowRef,width,height }: ToolProps) => {
  const {
    image: [image],
    maskImg: [maskImg, setMaskImg],
    allThingmoji: [allThingmoji, setAllThingmoji],
    thingmoji:  [thingmoji, setThingmoji],
    // intervalthingmoji: intervalthingmoji
    message: [message, setMessage],
    // currentThingMoji: [currentThingMoji, setCurrentThingMoji]
  } = useContext(AppContext)!;
  let item: any = null;
  
  const imageId = useRef<number>(0);
  const intervalthingmoji = useRef<any>(null);



  const imageToUint8Array = (image: HTMLImageElement) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    var imgWidth = image?.width || image?.naturalWidth;
    var imgHeight = image?.height || image?.naturalHeight;

    console.log("width,height:",imgWidth,imgHeight)

    canvas.width = imgWidth
    canvas.height = imgHeight
    // if ()
    // image.onload = () => {
    context?.drawImage(image, 0, 0);
    // }
    // context?.drawImage(image, 0, 0);
    // const canvas_focus = document.createElement("canvas");
    // const context_focus = canvas_focus.getContext("2d");
    // context_focus?.drawImage(image, 0, 0);

    // `getImageData().data` is a `Uint8ClampedArray`, which differs from `Uint8Array` only in
    // how data is treated when values are being *set*, so it is valid to perform the conversion
    // into a `Uint8Array`.
    return context? new Uint8Array(context.getImageData(0, 0, imgWidth, imgHeight).data.buffer):null;
  }

  const handleAccept = () => {
    if (document.getElementById("thingmoji_temp") !== null){
      document.getElementById("float-thingmoji")?.removeChild(document.getElementById("thingmoji_temp")!);
    }
    const floatLoading = document.getElementById("float-loading");
    if (floatLoading !== null) {
      floatLoading.style.display = "none";
    }
    const imageData = image ? imageToUint8Array(image) : null;
    const maskImgData = maskImg ? imageToUint8Array(maskImg) : null;
    
    if (image && maskImg && imageData && maskImgData) {
      imageId.current += 1;
      const imageId_temp = imageId.current;
      ///change the transparent to white
      const segmentation = new Uint8ClampedArray(maskImgData.map((pixel, index) => pixel === 0 ? 255 : imageData[index]));
      // const dimmedImage = new Uint8ClampedArray(maskImgData.map((pixel, index) => pixel === 0 ? imageData[index] : imageData[index] * 0.5));
      const croppedImage = removeBlankSpace(new ImageData(new Uint8ClampedArray(segmentation), image.width, image.height), image.width, image.height);
      const imageDic = DimBlankSpace(new ImageData(new Uint8ClampedArray(segmentation), image.width, image.height), image.width, image.height,image,imageData);
      //when next item comes, remove the previous thingmoji and sent the thingmoji to the remote user


      croppedImage.addEventListener('load', event => {
        const resized = resizeImage(croppedImage, 100);
        const resized_Original = resizeImage_original(imageDic, 400);
        item = {
          resizedImage: resized,
          originalImage: resized_Original,
        };
        
        
        setThingmoji(item);
        resized.id = "thingmoji_temp";
        resized.classList.add("jiggle")
        resized.classList.add("fadeOut")
        resized.classList.add("animated")
        resized.classList.add(`thingmoji_temp_${imageId_temp}`)
        //remove prior thingmoji when created new ones


        document.getElementById("float-thingmoji")?.appendChild(resized);
        //add image to messageinput
        handleThingmojiDoubleClick(message,setMessage,item.resizedImage.src,item.originalImage.src)

        // document.getElementById("contentEditable")?.focus();
        //set the cursor to the end of the messageinput
        //clear the innerhtml
        var val = document.getElementById("contentEditable")?.innerHTML;
        const inner = document.getElementById("contentEditable")
        if (inner!==null){
          inner.innerHTML = "";
          inner.innerHTML = val||"";
        }
        document.getElementById("contentEditable")?.focus();

        // document.getElementById("contentEditable").innerHTML = "";

        // //get the value of the element

        // var val = document.getElementById("contentEditable")?.innerHTML;
        // //clear the value of the element
        // document.getElementById("contentEditable")?.innerHTML = "";
        // //set the value of the element

        // document.getElementById("contentEditable")?.innerHTML = val;
        // // document.getElementById("contentEditable")?.focus();
        //  document.getElementById("float-span")?.addEventListener('click', event => {
          
        document.getElementById("thingmoji_temp")?.addEventListener('click', event => {
          event.stopPropagation();
          clearTimeout(intervalthingmoji.current);
          document.getElementById("float-thingmoji")?.style.setProperty("display", "none");
          document.getElementById("float-box")?.style.setProperty("display", "block");
          
          // setMaskImg(saveImageMask);
          // console.log(maskImg)
          // document.getElementById("float-box")?.style.setProperty("pointer", "none");

          setAllThingmoji(allThingmoji?.filter(thingmoji => thingmoji !== item) || null);
          //remove the previous item in messageinput
          // const message = message;
          setMessage(message
            ? {
                texts: message.texts,
                images: message.images.filter(image => image !== item),
                index: message.index
              }
            : null);

        }, false);



        setAllThingmoji(allThingmoji ? [...allThingmoji, item] : [item]);
        //send the thingmoji to remote user with six seconds delay
        // const handleThingmojiDoubleClick = (imageSrc,originImageSrc) => {
          // console.log(item,'---------------item--------------------')
          // const imageSrc = item.resizedImage.src;
          // const originImageSrc = item.originalImage.src; 
          // console.log(id)
          
 
        

        intervalthingmoji.current = setTimeout(() => {
          
          const floatThingmoji = document.getElementById("float-thingmoji");
          const tempThingmoji = document.getElementById("thingmoji_temp");
          if (tempThingmoji?.className.includes(`thingmoji_temp_${imageId_temp}`) && floatThingmoji) {
              if (floatThingmoji) {
                floatThingmoji.style.display = "none";
              }
              console.log("current one is the same as the previous one", imageId_temp)
          }
          thingmojiSend({resizedImage: item.resizedImage.src, originalImage: item.originalImage.src,
            // label: label
          });
          //
          
        }, 6000);

     
        // setAllThingmoji(allThingmoji ? [...allThingmoji, item] : [item]);
        
      
        // return item 
        // setMaskImg(null); //remove this to show the previous mask to the user. 
      }, false)



      // thingmoji_temp()


    }
    // test(croppedImage, imageDic, message);

    
    document.getElementById("float-box")?.style.setProperty("display", "none");
    document.getElementById("float-thingmoji")?.style.setProperty("display", "block");
    
  }

  // Determine if we should shrink or grow the images to match the
  // width or the height of the page and setup a ResizeObserver to
  // monitor changes in the size of the page
  async function getStream(dataURL:string, newItem: any) {
    // {id:socketRef.current.id,dataURL:dataURL,selectObject:false}
    // set embedding to null to avoid the previous embedding
    // setEmbeddingPath(null)
    // setImagePath(dataURL)
    const response = await fetch("http://localhost:8000/testlabel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    
    },
    body: `{
       "Id": 78912,
       "dataURL": "${dataURL}",
       "Price": 18.00
      }`,
    });

    response.json().then(async data => {
      //get the data from the server and load
      // console.log(JSON.stringify(data));
      const label = data.predicted_class
      newItem.label = label
      console.log(label)
      //send the label to other users once get the thingmoji label
      //compress the 
      // function base64ToBytes(base64: string) {
      //   const binString = atob(base64);
      //   const charCodes = binString.split('').map((m) => m.charCodeAt(0));
      //   return Uint8Array.from(charCodes);
      // }
      async function dataUrlToBytes(dataUrl: string) {
        const res = await fetch(dataUrl);
        return new Uint8Array(await res.arrayBuffer());
      }

      // const resizedImage = await (async () => {
      //   return dataUrlToBytes(newItem.resizedImage.src);
      // })();
      // const originalImage = await (async () => {
      //   return dataUrlToBytes(newItem.originalImage.src);
      // })();
      // const originalImage = await dataUrlToBytes(newItem.originalImage.src);
      // const bytes = base64ToBytes(dataURL.split(',')[1])   
      // thingmojiSend({resizedImage: resizedImage,
      //   originalImage: originalImage,
      //   label: label});   
      thingmojiSend({resizedImage: newItem.resizedImage.src, originalImage: newItem.originalImage.src,
      label: label});
      // return newItem

      // const bytes = Uint8Array.from(datanp, c => c.charCodeAt(0))
      // const floats = new Float32Array(bytes.buffer)
   
    });
  }

  const [shouldFitToWidth, setShouldFitToWidth] = useState(true);
  const bodyEl = document.body;
  const fitToPage = () => {
    if (!image) return;
    const imageAspectRatio = image.width / image.height;
    const screenAspectRatio = window.innerWidth / window.innerHeight;
    setShouldFitToWidth(imageAspectRatio > screenAspectRatio);
  };
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target === bodyEl) {
        fitToPage();
      }
    }
  });
  useEffect(() => {
   
    fitToPage();
    resizeObserver.observe(bodyEl);
    return () => {
      resizeObserver.unobserve(bodyEl);
    };
  }, [image]);

  useEffect(() => {
    if(maskImg!==null &&maskImg.width!==0 && maskImg.height!==0){
      //if next thingmoji comes, remove the previous thingmoji set time and sent the previous thingmoji directly to the remote user
      if (item !== null){
        clearTimeout(intervalthingmoji.current);
        thingmojiSend({resizedImage: item.resizedImage.src, originalImage: item.originalImage.src,
          // label: label
        });
       }
      handleAccept()
    }else if (maskImg!==null &&maskImg.width===0 && maskImg.height===0){
      //if the mask is empty, 
      console.log(maskImg)
      // document.body.appendChild(maskImg)
      //call the function until the mask is not empty
      // alert("sorry, mask is empaty please select the object again")
      setTimeout(() => {
        // document.body.removeChild(maskImg)
        // console.log("mask is empty")
        handleAccept()
      }, 1000);
      
    }
  }, [maskImg]);

  

  // const imageClasses = "";
  // const maskImageClasses = `absolute opacity-40 pointer-events-none`;

  // Render the image and the predicted mask image on top
  return (
    <>
      <canvas style={{zIndex:5,pointerEvents:"none",position:"absolute",cursor:"crosshair"}} ref={peekwindowRef}
      width={width} height={height}></canvas>
      {image && (
        <img
          id = "seg-image"
          onMouseMove={handleMouseMove}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          // onMouseOut={() => _.defer(() => setMaskImg(null))}
          onTouchStart={handleMouseDown}
          onTouchMove={handleMouseMove}
          onTouchEnd={handleMouseUp}
          src={image.src}
          className="h-100"
          // style={{cursor: maskImg === null ? "cell" : "pointer"}}
          style={{cursor: "cell",zIndex:3}}
        ></img>
      )}
      {maskImg && (
        <img
          id = "seg-mask"
          src={maskImg.src}
          className="h-100 top-0 start-0 position-absolute pe-none"
          style={{opacity: 0.5,zIndex:4}}
        ></img>
      )}

      <Collapse in={maskImg!==null}>
      <Button size='sm' variant="success" className="position-absolute bottom-0 end-0"
      onClick={()=>{handleAccept()}}>
        <CheckCircleFill/>
      </Button>
      </Collapse>
    </>
  );
};

export default Tool;
